/**
 * Per-SKU probe settings edited in the 探测设置 drawer (#2658 follow-up):
 * field specs grouped by level, draft ↔ stored values, the PATCH of changed
 * fields only, and the checks the gateway's write face applies (mirrored so
 * a refused value never leaves the page). Pure; no React.
 */
import {
  GUARANTEED_PROBE_ALERT_CALM_MINUTES_DEFAULT,
  GUARANTEED_PROBE_ALERT_FIRST_BYTE_LATE_MS_DEFAULT,
  GUARANTEED_PROBE_ALERT_FIRST_BYTE_LATE_MS_MAX,
  GUARANTEED_PROBE_ALERT_FIRST_BYTE_LATE_MS_MIN,
  GUARANTEED_PROBE_ALERT_CALM_MINUTES_MAX,
  GUARANTEED_PROBE_ALERT_CALM_MINUTES_MIN,
  GUARANTEED_PROBE_ALERT_INTERVAL_SECONDS_DEFAULT,
  GUARANTEED_PROBE_ALERT_INTERVAL_SECONDS_MAX,
  GUARANTEED_PROBE_ALERT_INTERVAL_SECONDS_MIN,
  GUARANTEED_PROBE_ALERT_MIN_FAILURES_DEFAULT,
  GUARANTEED_PROBE_ALERT_MIN_FAILURES_MAX,
  GUARANTEED_PROBE_ALERT_MIN_FAILURES_MIN,
  GUARANTEED_PROBE_ALERT_MIN_FAIL_PCT_DEFAULT,
  GUARANTEED_PROBE_ALERT_MIN_FAIL_PCT_MAX,
  GUARANTEED_PROBE_ALERT_MIN_FAIL_PCT_MIN,
  GUARANTEED_PROBE_BURST_EXIT_GOOD_WAVES_DEFAULT,
  GUARANTEED_PROBE_BURST_EXIT_GOOD_WAVES_MAX,
  GUARANTEED_PROBE_BURST_EXIT_GOOD_WAVES_MIN,
  GUARANTEED_PROBE_BURST_MAX_SECONDS_DEFAULT,
  GUARANTEED_PROBE_BURST_MAX_SECONDS_MAX,
  GUARANTEED_PROBE_BURST_MAX_SECONDS_MIN,
  GUARANTEED_PROBE_BURST_WAVE_EVERY_SECONDS_DEFAULT,
  GUARANTEED_PROBE_BURST_WAVE_EVERY_SECONDS_MAX,
  GUARANTEED_PROBE_BURST_WAVE_EVERY_SECONDS_MIN,
  GUARANTEED_PROBE_BURST_WAVE_FAIL_SHOTS_DEFAULT,
  GUARANTEED_PROBE_BURST_WAVE_FAIL_SHOTS_MIN,
  GUARANTEED_PROBE_BURST_WAVE_SHOTS_DEFAULT,
  GUARANTEED_PROBE_BURST_WAVE_SHOTS_MAX,
  GUARANTEED_PROBE_BURST_WAVE_SHOTS_MIN,
  GUARANTEED_PROBE_BURST_WAVES_TO_TRIP_DEFAULT,
  GUARANTEED_PROBE_BURST_WAVES_TO_TRIP_MAX,
  GUARANTEED_PROBE_BURST_WAVES_TO_TRIP_MIN,
  GUARANTEED_PROBE_CONFIRM_AFTER_SECONDS_DEFAULT,
  GUARANTEED_PROBE_CONFIRM_AFTER_SECONDS_MAX,
  GUARANTEED_PROBE_CONFIRM_AFTER_SECONDS_MIN,
  GUARANTEED_PROBE_INTERVAL_MINUTES_DEFAULT,
  GUARANTEED_PROBE_INTERVAL_MINUTES_MAX,
  GUARANTEED_PROBE_INTERVAL_MINUTES_MIN,
  GUARANTEED_PROBE_QUALITY_MIN_BAD_SHOTS_DEFAULT,
  GUARANTEED_PROBE_QUALITY_MIN_BAD_SHOTS_MAX,
  GUARANTEED_PROBE_QUALITY_MIN_BAD_SHOTS_MIN,
  GUARANTEED_PROBE_QUALITY_MIN_SHOTS_DEFAULT,
  GUARANTEED_PROBE_QUALITY_MIN_SHOTS_MAX,
  GUARANTEED_PROBE_QUALITY_MIN_SHOTS_MIN,
  GUARANTEED_PROBE_QUALITY_RECOVER_PCT_DEFAULT,
  GUARANTEED_PROBE_QUALITY_RECOVER_PCT_MIN,
  GUARANTEED_PROBE_QUALITY_RECOVER_WINDOW_MINUTES_DEFAULT,
  GUARANTEED_PROBE_QUALITY_RECOVER_WINDOW_MINUTES_MAX,
  GUARANTEED_PROBE_QUALITY_RECOVER_WINDOW_MINUTES_MIN,
  GUARANTEED_PROBE_QUALITY_TRIP_PCT_DEFAULT,
  GUARANTEED_PROBE_QUALITY_TRIP_PCT_MAX,
  GUARANTEED_PROBE_QUALITY_TRIP_PCT_MIN,
  GUARANTEED_PROBE_QUALITY_WINDOW_MINUTES_DEFAULT,
  GUARANTEED_PROBE_QUALITY_WINDOW_MINUTES_MAX,
  GUARANTEED_PROBE_QUALITY_WINDOW_MINUTES_MIN,
  GUARANTEED_PROBE_RECOVER_OK_ROUNDS_DEFAULT,
  GUARANTEED_PROBE_RECOVER_OK_ROUNDS_MAX,
  GUARANTEED_PROBE_SHOT_SPACING_SECONDS_DEFAULT,
  GUARANTEED_PROBE_SHOT_SPACING_SECONDS_MAX,
  GUARANTEED_PROBE_SHOT_SPACING_SECONDS_MIN,
  GUARANTEED_PROBE_SHOT_TIMEOUT_SECONDS_DEFAULT,
  GUARANTEED_PROBE_SHOT_TIMEOUT_SECONDS_MAX,
  GUARANTEED_PROBE_SHOT_TIMEOUT_SECONDS_MIN,
  GUARANTEED_PROBE_SHOTS_PER_ROUND_DEFAULT,
  GUARANTEED_PROBE_SHOTS_PER_ROUND_MAX,
  GUARANTEED_PROBE_SLOW_MS_DEFAULT,
  GUARANTEED_PROBE_SLOW_MS_MAX,
  GUARANTEED_PROBE_SLOW_MS_MIN,
  GUARANTEED_PROBE_TRIP_FAILED_ROUNDS_DEFAULT,
  GUARANTEED_PROBE_TRIP_FAILED_ROUNDS_MAX,
  GUARANTEED_PROBE_WAR_BACKOFF_RESET_MINUTES_DEFAULT,
  GUARANTEED_PROBE_WAR_BACKOFF_RESET_MINUTES_MAX,
  GUARANTEED_PROBE_WAR_BACKOFF_RESET_MINUTES_MIN,
  GUARANTEED_PROBE_WAR_COOLDOWN_BASE_MINUTES_DEFAULT,
  GUARANTEED_PROBE_WAR_COOLDOWN_BASE_MINUTES_MAX,
  GUARANTEED_PROBE_WAR_COOLDOWN_BASE_MINUTES_MIN,
  GUARANTEED_PROBE_WAR_COOLDOWN_FACTOR_DEFAULT,
  GUARANTEED_PROBE_WAR_COOLDOWN_FACTOR_MAX,
  GUARANTEED_PROBE_WAR_COOLDOWN_FACTOR_MIN,
  GUARANTEED_PROBE_WAR_COOLDOWN_MAX_MINUTES_DEFAULT,
  GUARANTEED_PROBE_WAR_COOLDOWN_MAX_MINUTES_MAX,
  guaranteedProbeRoundBudgetSeconds,
  guaranteedProbeSlowFitsTimeout,
  isGuaranteedProbeAlertCalmMinutes,
  isGuaranteedProbeAlertFirstByteLateMs,
  isGuaranteedProbeAlertIntervalSeconds,
  isGuaranteedProbeAlertMinFailPct,
  isGuaranteedProbeAlertMinFailures,
  isGuaranteedProbeBurstExitGoodWaves,
  isGuaranteedProbeBurstMaxSeconds,
  isGuaranteedProbeBurstWaveEverySeconds,
  isGuaranteedProbeBurstWaveFailShots,
  isGuaranteedProbeBurstWaveShots,
  isGuaranteedProbeBurstWavesToTrip,
  isGuaranteedProbeConfirmAfterSeconds,
  isGuaranteedProbeQualityMinBadShots,
  isGuaranteedProbeQualityMinShots,
  isGuaranteedProbeQualityRecoverPct,
  isGuaranteedProbeQualityRecoverWindowMinutes,
  isGuaranteedProbeQualityTripPct,
  isGuaranteedProbeQualityWindowMinutes,
  isGuaranteedProbeRecoverOkRounds,
  isGuaranteedProbeShotSpacingSeconds,
  isGuaranteedProbeShotsPerRound,
  isGuaranteedProbeShotTimeoutSeconds,
  isGuaranteedProbeSlowMs,
  isGuaranteedProbeTripFailedRounds,
  isGuaranteedProbeWarBackoffResetMinutes,
  isGuaranteedProbeWarCooldownBaseMinutes,
  isGuaranteedProbeWarCooldownFactor,
  isGuaranteedProbeWarCooldownMaxMinutes,
  type GuaranteedServiceSkuEntry,
  type PatchGuaranteedServiceSkuRequest,
} from '@nadoutong/contracts';
import type { I18nKey, TParams } from '../../i18n/index.ts';

/** The probe interval: an integer 1–1440; new rows start at 15 (30 before #2658 tuning). */
export const PROBE_INTERVAL_MINUTES_DEFAULT = GUARANTEED_PROBE_INTERVAL_MINUTES_DEFAULT;
export const PROBE_INTERVAL_MINUTES_MIN = GUARANTEED_PROBE_INTERVAL_MINUTES_MIN;
export const PROBE_INTERVAL_MINUTES_MAX = GUARANTEED_PROBE_INTERVAL_MINUTES_MAX;

export const PROBE_SECTIONS = ['normal', 'quality', 'alert', 'war', 'cooldown'] as const;
export type ProbeSection = (typeof PROBE_SECTIONS)[number];

export const PROBE_FIELDS = [
  'probe_interval_minutes',
  'probe_shots_per_round',
  'probe_shot_spacing_seconds',
  'probe_shot_timeout_seconds',
  'probe_slow_ms',
  'probe_confirm_after_seconds',
  'probe_trip_failed_rounds',
  'probe_recover_ok_rounds',
  'probe_quality_window_minutes',
  'probe_quality_min_shots',
  'probe_quality_trip_pct',
  'probe_quality_min_bad_shots',
  'probe_quality_recover_pct',
  'probe_quality_recover_window_minutes',
  'probe_alert_interval_seconds',
  'probe_alert_calm_minutes',
  'probe_alert_min_failures',
  'probe_alert_min_fail_pct',
  'probe_alert_first_byte_late_ms',
  'probe_burst_wave_shots',
  'probe_burst_wave_every_seconds',
  'probe_burst_wave_fail_shots',
  'probe_burst_waves_to_trip',
  'probe_burst_max_seconds',
  'probe_burst_exit_good_waves',
  'probe_war_cooldown_base_minutes',
  'probe_war_cooldown_factor',
  'probe_war_cooldown_max_minutes',
  'probe_war_backoff_reset_minutes',
] as const;
export type ProbeField = (typeof PROBE_FIELDS)[number];
export type ProbeValues = Readonly<Record<ProbeField, number>>;

type ProbeUnit = 'minutes' | 'seconds' | 'ms' | 'shots' | 'rounds' | 'pct' | 'failures' | 'waves' | 'times';

export interface ProbeFieldSpec {
  readonly field: ProbeField;
  readonly section: ProbeSection;
  readonly label: I18nKey;
  readonly unit: ProbeUnit;
  readonly defaultValue: number;
  /** Static bounds; a few fields are further bound by another field (see {@link fieldBounds}). */
  readonly min: number;
  readonly max: number;
  readonly valid: (value: number, values: ProbeValues) => boolean;
}

function spec(
  field: ProbeField,
  section: ProbeSection,
  label: I18nKey,
  unit: ProbeUnit,
  defaultValue: number,
  bounds: readonly [number, number],
  valid: (value: number, values: ProbeValues) => boolean,
): ProbeFieldSpec {
  return { field, section, label, unit, defaultValue, min: bounds[0], max: bounds[1], valid };
}

export const PROBE_FIELD_SPECS: readonly ProbeFieldSpec[] = [
  spec('probe_interval_minutes', 'normal', 'guaranteed.probe_settings.field.interval', 'minutes',
    PROBE_INTERVAL_MINUTES_DEFAULT, [PROBE_INTERVAL_MINUTES_MIN, PROBE_INTERVAL_MINUTES_MAX],
    (value) => Number.isSafeInteger(value) && value >= PROBE_INTERVAL_MINUTES_MIN && value <= PROBE_INTERVAL_MINUTES_MAX),
  spec('probe_shots_per_round', 'normal', 'guaranteed.probe_settings.field.shots', 'shots',
    GUARANTEED_PROBE_SHOTS_PER_ROUND_DEFAULT, [1, GUARANTEED_PROBE_SHOTS_PER_ROUND_MAX], isGuaranteedProbeShotsPerRound),
  spec('probe_shot_spacing_seconds', 'normal', 'guaranteed.probe_settings.field.spacing', 'seconds',
    GUARANTEED_PROBE_SHOT_SPACING_SECONDS_DEFAULT,
    [GUARANTEED_PROBE_SHOT_SPACING_SECONDS_MIN, GUARANTEED_PROBE_SHOT_SPACING_SECONDS_MAX], isGuaranteedProbeShotSpacingSeconds),
  spec('probe_shot_timeout_seconds', 'normal', 'guaranteed.probe_settings.field.timeout', 'seconds',
    GUARANTEED_PROBE_SHOT_TIMEOUT_SECONDS_DEFAULT,
    [GUARANTEED_PROBE_SHOT_TIMEOUT_SECONDS_MIN, GUARANTEED_PROBE_SHOT_TIMEOUT_SECONDS_MAX], isGuaranteedProbeShotTimeoutSeconds),
  spec('probe_slow_ms', 'normal', 'guaranteed.probe_settings.field.slow', 'ms',
    GUARANTEED_PROBE_SLOW_MS_DEFAULT, [GUARANTEED_PROBE_SLOW_MS_MIN, GUARANTEED_PROBE_SLOW_MS_MAX], isGuaranteedProbeSlowMs),
  spec('probe_confirm_after_seconds', 'normal', 'guaranteed.probe_settings.field.confirm', 'seconds',
    GUARANTEED_PROBE_CONFIRM_AFTER_SECONDS_DEFAULT,
    [GUARANTEED_PROBE_CONFIRM_AFTER_SECONDS_MIN, GUARANTEED_PROBE_CONFIRM_AFTER_SECONDS_MAX], isGuaranteedProbeConfirmAfterSeconds),
  spec('probe_trip_failed_rounds', 'normal', 'guaranteed.probe_settings.field.fail_rounds', 'rounds',
    GUARANTEED_PROBE_TRIP_FAILED_ROUNDS_DEFAULT, [1, GUARANTEED_PROBE_TRIP_FAILED_ROUNDS_MAX], isGuaranteedProbeTripFailedRounds),
  spec('probe_recover_ok_rounds', 'normal', 'guaranteed.probe_settings.field.pass_rounds', 'rounds',
    GUARANTEED_PROBE_RECOVER_OK_ROUNDS_DEFAULT, [1, GUARANTEED_PROBE_RECOVER_OK_ROUNDS_MAX], isGuaranteedProbeRecoverOkRounds),
  spec('probe_quality_window_minutes', 'quality', 'guaranteed.probe_settings.field.quality_window', 'minutes',
    GUARANTEED_PROBE_QUALITY_WINDOW_MINUTES_DEFAULT,
    [GUARANTEED_PROBE_QUALITY_WINDOW_MINUTES_MIN, GUARANTEED_PROBE_QUALITY_WINDOW_MINUTES_MAX], isGuaranteedProbeQualityWindowMinutes),
  spec('probe_quality_min_shots', 'quality', 'guaranteed.probe_settings.field.quality_min', 'shots',
    GUARANTEED_PROBE_QUALITY_MIN_SHOTS_DEFAULT,
    [GUARANTEED_PROBE_QUALITY_MIN_SHOTS_MIN, GUARANTEED_PROBE_QUALITY_MIN_SHOTS_MAX], isGuaranteedProbeQualityMinShots),
  spec('probe_quality_trip_pct', 'quality', 'guaranteed.probe_settings.field.quality_trip', 'pct',
    GUARANTEED_PROBE_QUALITY_TRIP_PCT_DEFAULT,
    [GUARANTEED_PROBE_QUALITY_TRIP_PCT_MIN, GUARANTEED_PROBE_QUALITY_TRIP_PCT_MAX], isGuaranteedProbeQualityTripPct),
  spec('probe_quality_min_bad_shots', 'quality', 'guaranteed.probe_settings.field.quality_min_bad', 'shots',
    GUARANTEED_PROBE_QUALITY_MIN_BAD_SHOTS_DEFAULT,
    [GUARANTEED_PROBE_QUALITY_MIN_BAD_SHOTS_MIN, GUARANTEED_PROBE_QUALITY_MIN_BAD_SHOTS_MAX], isGuaranteedProbeQualityMinBadShots),
  spec('probe_quality_recover_pct', 'quality', 'guaranteed.probe_settings.field.quality_recover', 'pct',
    GUARANTEED_PROBE_QUALITY_RECOVER_PCT_DEFAULT,
    [GUARANTEED_PROBE_QUALITY_RECOVER_PCT_MIN, GUARANTEED_PROBE_QUALITY_TRIP_PCT_MAX],
    (value, values) => isGuaranteedProbeQualityRecoverPct(value, values.probe_quality_trip_pct)),
  spec('probe_quality_recover_window_minutes', 'quality', 'guaranteed.probe_settings.field.quality_recover_window', 'minutes',
    GUARANTEED_PROBE_QUALITY_RECOVER_WINDOW_MINUTES_DEFAULT,
    [GUARANTEED_PROBE_QUALITY_RECOVER_WINDOW_MINUTES_MIN, GUARANTEED_PROBE_QUALITY_RECOVER_WINDOW_MINUTES_MAX],
    isGuaranteedProbeQualityRecoverWindowMinutes),
  spec('probe_alert_interval_seconds', 'alert', 'guaranteed.probe_settings.field.alert_interval', 'seconds',
    GUARANTEED_PROBE_ALERT_INTERVAL_SECONDS_DEFAULT,
    [GUARANTEED_PROBE_ALERT_INTERVAL_SECONDS_MIN, GUARANTEED_PROBE_ALERT_INTERVAL_SECONDS_MAX], isGuaranteedProbeAlertIntervalSeconds),
  spec('probe_alert_calm_minutes', 'alert', 'guaranteed.probe_settings.field.alert_calm', 'minutes',
    GUARANTEED_PROBE_ALERT_CALM_MINUTES_DEFAULT,
    [GUARANTEED_PROBE_ALERT_CALM_MINUTES_MIN, GUARANTEED_PROBE_ALERT_CALM_MINUTES_MAX], isGuaranteedProbeAlertCalmMinutes),
  spec('probe_alert_min_failures', 'alert', 'guaranteed.probe_settings.field.alert_failures', 'failures',
    GUARANTEED_PROBE_ALERT_MIN_FAILURES_DEFAULT,
    [GUARANTEED_PROBE_ALERT_MIN_FAILURES_MIN, GUARANTEED_PROBE_ALERT_MIN_FAILURES_MAX], isGuaranteedProbeAlertMinFailures),
  spec('probe_alert_min_fail_pct', 'alert', 'guaranteed.probe_settings.field.alert_fail_pct', 'pct',
    GUARANTEED_PROBE_ALERT_MIN_FAIL_PCT_DEFAULT,
    [GUARANTEED_PROBE_ALERT_MIN_FAIL_PCT_MIN, GUARANTEED_PROBE_ALERT_MIN_FAIL_PCT_MAX], isGuaranteedProbeAlertMinFailPct),
  // 0 = off, else 1000–300000 (#2658 tuning, 0088): the range check names both.
  spec('probe_alert_first_byte_late_ms', 'alert', 'guaranteed.probe_settings.field.alert_first_byte_late', 'ms',
    GUARANTEED_PROBE_ALERT_FIRST_BYTE_LATE_MS_DEFAULT,
    [0, GUARANTEED_PROBE_ALERT_FIRST_BYTE_LATE_MS_MAX], isGuaranteedProbeAlertFirstByteLateMs),
  spec('probe_burst_wave_shots', 'war', 'guaranteed.probe_settings.field.wave_shots', 'shots',
    GUARANTEED_PROBE_BURST_WAVE_SHOTS_DEFAULT,
    [GUARANTEED_PROBE_BURST_WAVE_SHOTS_MIN, GUARANTEED_PROBE_BURST_WAVE_SHOTS_MAX], isGuaranteedProbeBurstWaveShots),
  spec('probe_burst_wave_every_seconds', 'war', 'guaranteed.probe_settings.field.wave_every', 'seconds',
    GUARANTEED_PROBE_BURST_WAVE_EVERY_SECONDS_DEFAULT,
    [GUARANTEED_PROBE_BURST_WAVE_EVERY_SECONDS_MIN, GUARANTEED_PROBE_BURST_WAVE_EVERY_SECONDS_MAX], isGuaranteedProbeBurstWaveEverySeconds),
  spec('probe_burst_wave_fail_shots', 'war', 'guaranteed.probe_settings.field.wave_fail', 'shots',
    GUARANTEED_PROBE_BURST_WAVE_FAIL_SHOTS_DEFAULT,
    [GUARANTEED_PROBE_BURST_WAVE_FAIL_SHOTS_MIN, GUARANTEED_PROBE_BURST_WAVE_SHOTS_MAX],
    (value, values) => isGuaranteedProbeBurstWaveFailShots(value, values.probe_burst_wave_shots)),
  spec('probe_burst_waves_to_trip', 'war', 'guaranteed.probe_settings.field.waves_to_trip', 'waves',
    GUARANTEED_PROBE_BURST_WAVES_TO_TRIP_DEFAULT,
    [GUARANTEED_PROBE_BURST_WAVES_TO_TRIP_MIN, GUARANTEED_PROBE_BURST_WAVES_TO_TRIP_MAX], isGuaranteedProbeBurstWavesToTrip),
  spec('probe_burst_max_seconds', 'war', 'guaranteed.probe_settings.field.war_max', 'seconds',
    GUARANTEED_PROBE_BURST_MAX_SECONDS_DEFAULT,
    [GUARANTEED_PROBE_BURST_MAX_SECONDS_MIN, GUARANTEED_PROBE_BURST_MAX_SECONDS_MAX], isGuaranteedProbeBurstMaxSeconds),
  spec('probe_burst_exit_good_waves', 'war', 'guaranteed.probe_settings.field.exit_good', 'waves',
    GUARANTEED_PROBE_BURST_EXIT_GOOD_WAVES_DEFAULT,
    [GUARANTEED_PROBE_BURST_EXIT_GOOD_WAVES_MIN, GUARANTEED_PROBE_BURST_EXIT_GOOD_WAVES_MAX], isGuaranteedProbeBurstExitGoodWaves),
  spec('probe_war_cooldown_base_minutes', 'cooldown', 'guaranteed.probe_settings.field.cool_base', 'minutes',
    GUARANTEED_PROBE_WAR_COOLDOWN_BASE_MINUTES_DEFAULT,
    [GUARANTEED_PROBE_WAR_COOLDOWN_BASE_MINUTES_MIN, GUARANTEED_PROBE_WAR_COOLDOWN_BASE_MINUTES_MAX], isGuaranteedProbeWarCooldownBaseMinutes),
  spec('probe_war_cooldown_factor', 'cooldown', 'guaranteed.probe_settings.field.cool_factor', 'times',
    GUARANTEED_PROBE_WAR_COOLDOWN_FACTOR_DEFAULT,
    [GUARANTEED_PROBE_WAR_COOLDOWN_FACTOR_MIN, GUARANTEED_PROBE_WAR_COOLDOWN_FACTOR_MAX], isGuaranteedProbeWarCooldownFactor),
  spec('probe_war_cooldown_max_minutes', 'cooldown', 'guaranteed.probe_settings.field.cool_max', 'minutes',
    GUARANTEED_PROBE_WAR_COOLDOWN_MAX_MINUTES_DEFAULT,
    [GUARANTEED_PROBE_WAR_COOLDOWN_BASE_MINUTES_MIN, GUARANTEED_PROBE_WAR_COOLDOWN_MAX_MINUTES_MAX],
    (value, values) => isGuaranteedProbeWarCooldownMaxMinutes(value, values.probe_war_cooldown_base_minutes)),
  spec('probe_war_backoff_reset_minutes', 'cooldown', 'guaranteed.probe_settings.field.cool_reset', 'minutes',
    GUARANTEED_PROBE_WAR_BACKOFF_RESET_MINUTES_DEFAULT,
    [GUARANTEED_PROBE_WAR_BACKOFF_RESET_MINUTES_MIN, GUARANTEED_PROBE_WAR_BACKOFF_RESET_MINUTES_MAX], isGuaranteedProbeWarBackoffResetMinutes),
];

export function specsOf(section: ProbeSection): readonly ProbeFieldSpec[] {
  return PROBE_FIELD_SPECS.filter((entry) => entry.section === section);
}

export function specOf(field: ProbeField): ProbeFieldSpec {
  const found = PROBE_FIELD_SPECS.find((entry) => entry.field === field);
  if (found === undefined) throw new Error(`no probe field spec for ${field}`);
  return found;
}

/** One value per field, spelled out once so the record type needs no cast. */
export function probeRecord<V>(pick: (field: ProbeField) => V): Readonly<Record<ProbeField, V>> {
  return {
    probe_interval_minutes: pick('probe_interval_minutes'),
    probe_shots_per_round: pick('probe_shots_per_round'),
    probe_shot_spacing_seconds: pick('probe_shot_spacing_seconds'),
    probe_shot_timeout_seconds: pick('probe_shot_timeout_seconds'),
    probe_slow_ms: pick('probe_slow_ms'),
    probe_confirm_after_seconds: pick('probe_confirm_after_seconds'),
    probe_trip_failed_rounds: pick('probe_trip_failed_rounds'),
    probe_recover_ok_rounds: pick('probe_recover_ok_rounds'),
    probe_quality_window_minutes: pick('probe_quality_window_minutes'),
    probe_quality_min_shots: pick('probe_quality_min_shots'),
    probe_quality_trip_pct: pick('probe_quality_trip_pct'),
    probe_quality_min_bad_shots: pick('probe_quality_min_bad_shots'),
    probe_quality_recover_pct: pick('probe_quality_recover_pct'),
    probe_quality_recover_window_minutes: pick('probe_quality_recover_window_minutes'),
    probe_alert_interval_seconds: pick('probe_alert_interval_seconds'),
    probe_alert_calm_minutes: pick('probe_alert_calm_minutes'),
    probe_alert_min_failures: pick('probe_alert_min_failures'),
    probe_alert_min_fail_pct: pick('probe_alert_min_fail_pct'),
    probe_alert_first_byte_late_ms: pick('probe_alert_first_byte_late_ms'),
    probe_burst_wave_shots: pick('probe_burst_wave_shots'),
    probe_burst_wave_every_seconds: pick('probe_burst_wave_every_seconds'),
    probe_burst_wave_fail_shots: pick('probe_burst_wave_fail_shots'),
    probe_burst_waves_to_trip: pick('probe_burst_waves_to_trip'),
    probe_burst_max_seconds: pick('probe_burst_max_seconds'),
    probe_burst_exit_good_waves: pick('probe_burst_exit_good_waves'),
    probe_war_cooldown_base_minutes: pick('probe_war_cooldown_base_minutes'),
    probe_war_cooldown_factor: pick('probe_war_cooldown_factor'),
    probe_war_cooldown_max_minutes: pick('probe_war_cooldown_max_minutes'),
    probe_war_backoff_reset_minutes: pick('probe_war_backoff_reset_minutes'),
  };
}

export const PROBE_DEFAULTS: ProbeValues = probeRecord((field) => specOf(field).defaultValue);

/** The row's stored values; a field an older gateway omits reads as its contract default. */
export function probeValuesOf(row: GuaranteedServiceSkuEntry): ProbeValues {
  const record = new Map<string, unknown>(Object.entries(row));
  return probeRecord((field) => {
    const value = record.get(field);
    return typeof value === 'number' && Number.isSafeInteger(value) ? value : PROBE_DEFAULTS[field];
  });
}

/** Input text per field. */
export type ProbeDraft = Readonly<Record<ProbeField, string>>;

export function draftOf(values: ProbeValues): ProbeDraft {
  return probeRecord((field) => String(values[field]));
}

/** An integer typed into a field, else null (blank, decimal, text). */
export function parseDraftValue(text: string): number | null {
  const trimmed = text.trim();
  if (!/^-?\d+$/.test(trimmed)) return null;
  const value = Number(trimmed);
  return Number.isSafeInteger(value) ? value : null;
}

/** Draft values where they parse; the baseline elsewhere (their field is flagged invalid). */
export function draftValues(draft: ProbeDraft, baseline: ProbeValues): ProbeValues {
  return probeRecord((field) => parseDraftValue(draft[field]) ?? baseline[field]);
}

export function changedFields(draft: ProbeDraft, baseline: ProbeValues): readonly ProbeField[] {
  return PROBE_FIELDS.filter((field) => parseDraftValue(draft[field]) !== baseline[field]);
}

/**
 * A refetch landed mid-edit (another operator saved): fields the operator
 * has not changed from the old stored values take the new stored values;
 * the operator's own edits stay. The PATCH then carries only those edits,
 * never a stale copy of someone else's change (review M8).
 */
export function rebaseDraft(draft: ProbeDraft, oldBaseline: ProbeValues, newBaseline: ProbeValues): ProbeDraft {
  return probeRecord((field) => (parseDraftValue(draft[field]) === oldBaseline[field] ? String(newBaseline[field]) : draft[field]));
}

/** Only the fields whose parsed value differs from the stored row. */
export function probePatch(draft: ProbeDraft, baseline: ProbeValues): PatchGuaranteedServiceSkuRequest {
  const body: Partial<Record<ProbeField, number>> = {};
  for (const field of PROBE_FIELDS) {
    const value = parseDraftValue(draft[field]);
    if (value !== null && value !== baseline[field]) body[field] = value;
  }
  return body;
}

/** The draft with one section's fields put back to the contract defaults. */
export function restoreSectionDefaults(draft: ProbeDraft, section: ProbeSection): ProbeDraft {
  return probeRecord((field) => (specOf(field).section === section ? String(PROBE_DEFAULTS[field]) : draft[field]));
}

export function sectionIsDefault(draft: ProbeDraft, section: ProbeSection): boolean {
  return specsOf(section).every((entry) => parseDraftValue(draft[entry.field]) === entry.defaultValue);
}

export interface ProbeIssue {
  readonly key: I18nKey;
  readonly params: TParams;
}

/** Bounds a field takes given the other values (recover ≤ trip, fail ≤ wave shots, max ≥ base). */
export function fieldBounds(field: ProbeField, values: ProbeValues): readonly [number, number] {
  const entry = specOf(field);
  if (field === 'probe_quality_recover_pct') return [entry.min, values.probe_quality_trip_pct];
  if (field === 'probe_burst_wave_fail_shots') return [entry.min, values.probe_burst_wave_shots];
  if (field === 'probe_war_cooldown_max_minutes') return [values.probe_war_cooldown_base_minutes, entry.max];
  return [entry.min, entry.max];
}

/**
 * Field → the first problem with it. Ranges come from the contract
 * validators; the cross-field checks mirror the gateway write face, including
 * WHEN it applies them: the round budget against the interval when the write
 * touches the interval, shots, spacing or timeout; the recheck delay against
 * the interval and the alert interval against the round budget only when that
 * field itself is written.
 */
export function probeIssues(draft: ProbeDraft, baseline: ProbeValues): ReadonlyMap<ProbeField, ProbeIssue> {
  const issues = new Map<ProbeField, ProbeIssue>();
  const values = draftValues(draft, baseline);
  const changed = new Set(changedFields(draft, baseline));
  for (const entry of PROBE_FIELD_SPECS) {
    const parsed = parseDraftValue(draft[entry.field]);
    if (parsed === null) {
      issues.set(entry.field, { key: 'guaranteed.probe_settings.err.integer', params: {} });
      continue;
    }
    if (!entry.valid(parsed, values)) {
      if (entry.field === 'probe_alert_first_byte_late_ms') {
        issues.set(entry.field, {
          key: 'guaranteed.probe_settings.err.first_byte_late',
          params: { min: GUARANTEED_PROBE_ALERT_FIRST_BYTE_LATE_MS_MIN, max: GUARANTEED_PROBE_ALERT_FIRST_BYTE_LATE_MS_MAX },
        });
        continue;
      }
      const [min, max] = fieldBounds(entry.field, values);
      issues.set(entry.field, { key: 'guaranteed.probe_settings.err.range', params: { min, max } });
    }
  }
  const budget = guaranteedProbeRoundBudgetSeconds({
    shots: values.probe_shots_per_round,
    spacingSeconds: values.probe_shot_spacing_seconds,
    timeoutSeconds: values.probe_shot_timeout_seconds,
  });
  const roundTouched = (['probe_interval_minutes', 'probe_shots_per_round', 'probe_shot_spacing_seconds', 'probe_shot_timeout_seconds'] as const)
    .some((field) => changed.has(field));
  if (roundTouched && budget > values.probe_interval_minutes * 60 && !issues.has('probe_interval_minutes')) {
    // Name the parts and the shortest interval that fits (the 1-minute ×
    // 3-shot refusal in the staging rehearsal said only "must fit").
    issues.set('probe_interval_minutes', {
      key: 'guaranteed.probe_settings.err.round_budget',
      params: {
        budget,
        interval: values.probe_interval_minutes * 60,
        shots: values.probe_shots_per_round,
        timeout: values.probe_shot_timeout_seconds,
        spacing: values.probe_shot_spacing_seconds,
        minutes: Math.ceil(budget / 60),
      },
    });
  }
  // The slow line cannot sit above the shot timeout (a shot is aborted
  // there); checked when the write touches either field, like the gateway,
  // and shown under the field(s) the operator changed (#2676 review P3-3).
  const slowPair = (['probe_slow_ms', 'probe_shot_timeout_seconds'] as const).filter((field) => changed.has(field));
  if (slowPair.length > 0 && !issues.has('probe_slow_ms') && !issues.has('probe_shot_timeout_seconds')
    && !guaranteedProbeSlowFitsTimeout(values.probe_slow_ms, values.probe_shot_timeout_seconds)) {
    const issue: ProbeIssue = {
      key: 'guaranteed.probe_settings.err.slow_timeout',
      params: { slow: values.probe_slow_ms, timeout: values.probe_shot_timeout_seconds, max: values.probe_shot_timeout_seconds * 1000 },
    };
    for (const field of slowPair) issues.set(field, issue);
  }
  if (changed.has('probe_confirm_after_seconds') && !issues.has('probe_confirm_after_seconds')
    && values.probe_confirm_after_seconds > values.probe_interval_minutes * 60) {
    issues.set('probe_confirm_after_seconds', {
      key: 'guaranteed.probe_settings.err.confirm_interval',
      params: { interval: values.probe_interval_minutes * 60 },
    });
  }
  if (changed.has('probe_alert_interval_seconds') && !issues.has('probe_alert_interval_seconds')
    && values.probe_alert_interval_seconds < budget) {
    issues.set('probe_alert_interval_seconds', { key: 'guaranteed.probe_settings.err.alert_budget', params: { budget } });
  }
  return issues;
}
